import React from "react";
import DealerSearch from "./DealerSearch";

const DealerSearchWrapper = () => {
  return <DealerSearch />;
};
export default DealerSearchWrapper;
